import { render, staticRenderFns } from "./RoleListComponent.vue?vue&type=template&id=e2bb6d12"
import script from "./RoleListComponent.vue?vue&type=script&lang=js"
export * from "./RoleListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports